import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { RootErrorBoundary } from './components/RootErrorBoundary'
import './styles/globals.css'

// task-xpoqxwdw18 — the boundary sits OUTSIDE <App/> and outside the router, because with no boundary
// at all a render-phase throw anywhere in the tree unmounted this entire root and left the user a
// blank document with nothing to report. It is a diagnostic surface, not a fix: see
// components/RootErrorBoundary.tsx for why it is not established as the cause of the reported blank page.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </React.StrictMode>,
)// Force rebuild Tue Sep 30 12:06:02 CEST 2025
